import type {
  LlmRequest,
  LlmResponse,
  LlmApiConfig,
  LlmApiPayload,
} from './types';

const DEFAULT_ENDPOINT = 'https://lti13.alchem.ie/v2/alttext';
const DEFAULT_TIMEOUT = 30_000;

function serializeData(data: string | object): string {
  return typeof data === 'object' ? JSON.stringify(data) : data;
}

export function buildPayload(request: LlmRequest): LlmApiPayload {
  const payload: LlmApiPayload = {};

  if (request.appName !== undefined) payload.appName = request.appName;
  if (request.systemPrompt !== undefined) payload.systemPrompt = request.systemPrompt;
  if (request.contextPrompt !== undefined) payload.contextPrompt = request.contextPrompt;
  if (request.model !== undefined) payload.model = request.model;

  if (request.data !== undefined) {
    payload.data = serializeData(request.data);
  }

  return payload;
}

export async function generate(
  request: LlmRequest,
  config?: LlmApiConfig
): Promise<LlmResponse> {
  const endpoint = config?.endpoint ?? DEFAULT_ENDPOINT;
  const timeout = config?.timeout ?? DEFAULT_TIMEOUT;

  const body = buildPayload(request);

  console.log('[llm-api] → POST', endpoint, body);

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeout);

  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: controller.signal,
    });

    if (!response.ok) {
      throw new Error(`LLM API error: ${response.status} ${response.statusText}`);
    }

    const raw = await response.text();
    let json: unknown = null;
    try {
      json = JSON.parse(raw);
    } catch {
      // Response is not JSON — raw text is still available
    }

    return { raw, json };
  } finally {
    clearTimeout(timer);
  }
}

export function createLlmClient(config?: LlmApiConfig) {
  return {
    generate: (request: LlmRequest) => generate(request, config),
  };
}
